<template>

    <b-modal id="ModalRecarga" :title="title" no-close-on-backdrop no-close-on-esc @hidden="closeModal">

        <template v-if="!isComplete">
            <!-- Contenido de recargas disponibles -->
            <h6>1.- Selecciona tu paquete</h6>
            <visor-planes-recarga v-model="dataToPurchase.offer" />
    
            <hr>
    
            <!-- Contenido de método de pago -->
            <h6>2.- Selecciona tu método de pago</h6>
            <metodosPagoStripe v-model="dataToPurchase.pm" allow-select @initialized="onMetodosPagoInitialized" />
        </template>

        <!-- Display de éxito -->
        <div class="text-center py-5" v-if="isComplete">
            <check-mark-icon />
            <h3 class="mt-4 text-success">¡Recarga completada!</h3>
            <p class="text-muted">Tu recarga se ha procesado exitosamente</p>
        </div>
    
        <template #modal-footer="{ cancel }" v-if="!isComplete">
            <b-button variant="secondary" @click="cancel()">
                Cancelar
            </b-button>
            <lock-button variant="primary" :is-processing="isProcessing" @click="continuePurchase()"
                :disabled="!dataToPurchase.pm || !dataToPurchase.offer">
                Procesar compra
            </lock-button>
        </template>

        <template #modal-footer="{ ok }" v-else>
            <b-button variant="primary" @click="ok()">
                Finalizar
            </b-button>
        </template>

        <div v-if="debug" class="debug">
            <pre>{{ dataToPurchase }}</pre>
        </div>

    </b-modal>

</template>

<script>
import axios from 'axios'
import visorPlanesRecarga from './visor-planes-recarga.vue';
import stripeObj from '@/stripe/stripeHandler'
import { notify } from '@/utils';

const steps = {
    SELECT_OFFER_AND_PM: 1,
    CREATE_PAYMENT_INTENT: 2,
    CONFIRM_PAYMENT: 3,
    COMPLETE: 4
};

export default {
    name: 'ModalRecarga',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        msisdn: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: 'Recarga de saldo'
        }
    },
    components: {
        visorPlanesRecarga
    },
    data: () => ({
        isProcessing: false,
        isComplete: false,
        currentStep: steps.SELECT_OFFER_AND_PM,
        paymentIntent: null,
        checkoutSessionPayment: null,
        stripe: null,
        dataToPurchase: {
            pm: null,
            offer: null,
        }
    }),
    methods: {
        async confirmPIntent4ExtentionPurchase() {
            let form = {
                ofertaData: this.dataToPurchase.offer,
                msisdn: this.msisdn,
                pm: { id: this.dataToPurchase.pm },
                confirmResult: null
            }, resp;

            // VALIDACIÓN DINCÁMICA DEL PM.
            form.confirmResult = await this._validatePM(this.dataToPurchase.pm);

            // RESP
            resp = await axios.post('index.php?r=api/extentions/buy', form);

            // RESP STATUS
            if (resp.status)
                return true;
            else
                throw resp;
        },
        async createPaymentIntent() {
            const response = await axios.post('index.php?r=api/extentions/createpaymentintent', {
                msisdn: this.msisdn,
                ofertaData: this.dataToPurchase.offer,
            });
            // RESP STATUS
            if (response.status) {
                this.paymentIntent = response.data.paymentIntentObj;
                this.checkoutSessionPayment = response.data.checkoutSessionPayment;
            }
            return response.data;
        },
        async continuePurchase() {
            this.isProcessing = true;
            try {
                await this._performPurchase();
            } catch (e) {
                this.currentStep = steps.SELECT_OFFER_AND_PM;
                notify((typeof e === 'string' ? e : 'Ocurrió un error al procesar la recarga. Inténtalo de nuevo.'));
            } finally {
                this.isProcessing = false;
            }
        },
        async _performPurchase(){
            switch (this.currentStep) {
                case steps.SELECT_OFFER_AND_PM:
                    await this.createPaymentIntent();
                    this.currentStep = steps.CONFIRM_PAYMENT;
                    await this._performPurchase();
                    break;
                case steps.CONFIRM_PAYMENT:
                    // Lógica para confirmar el pago
                    await this.confirmPIntent4ExtentionPurchase();
                    this.currentStep = steps.COMPLETE;
                    await this._performPurchase();
                    break;
                case steps.COMPLETE:
                    // Lógica para confirmar el pago
                    this.isComplete = true;
                    break;
                default:
                    break;
            }
        },
        async _validatePM(paymentMethodId) {
            if (!paymentMethodId)
                throw 'Debes seleccionar el método de pago';
            const confirmResult = await this.stripe.confirmCardPayment(this.paymentIntent.client_secret, {
                payment_method: paymentMethodId,
            });
            if (confirmResult.error)
                throw confirmResult.error.message;
            return confirmResult;
        },
        onMetodosPagoInitialized() {
            if (!this.stripe)
                this.stripe = stripeObj.initialize()
        },
        show() {
            this.$bvModal.show('ModalRecarga');
        },
        closeModal() {
            // Lógica al cerrar el modal si es necesario
            this.dataToPurchase = {
                pm: null,
                offer: null,
            };
            this.isComplete = false;
            this.currentStep = steps.SELECT_OFFER_AND_PM;
        },
    },
}
</script>

<style lang="scss">
@import '@/scss/app.scss';

h6 {
    margin-top: 3em;
    color: $primary;
    font-weight: bold;
    margin-bottom: 1.5em;
    // padding-bottom: 0.5em;
    // border-bottom: 0.1em solid $primary;
}
</style>